import type { CommonState } from '../types';

export const getDialogError = (state: CommonState) => state.errorDialog.dialogError;
